import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    location: ''
};

export function locationReducer(state=initialState, action) {
    switch (action.type) {
        case actionTypes.STORE_LOCATION :
            return updateState(state, {
                location: action.location
            });

        case actionTypes.REMOVE_LOCATION :
            return updateState(state, {
                location: ''
            });

        default :
            return state;
    }
}